<template>
  <div
    class="block static w-[520px] h-full max-h-full left-50 bg-gray-300 border-gray-400"
  >
    <h3 class="flex justify-center pt-3 font-bold">Daily Scene</h3>
    <svg id="map-svg" class="hidden"></svg>
    <div
      class="max-h-[615px] overflow-y-auto pt-5"
      v-if="!bykodepetak.loading || !sgnbykodepetak.loading"
    >
      <div v-if="bykodepetak.rows?.length != 0">
        <div
          class="flex flex-col py-2 px-3"
          v-for="item in bykodepetak.rows"
          :key="item.feature_id"
          :class="[
            { 'hover:bg-[#c3c8d0]': selected != item.tanggal },
            { 'bg-[#c3c8d0]': selected == item.tanggal },
          ]"
        >
          <div class="flex gap-5">
            <div
              class="bg-[#e9f1fc] px-3 py-3 rounded-md flex justify-center items-center"
            >
              <img :src="dataURL" :width="85" :height="85" alt="Geofence Image" />
            </div>

            <div class="flex flex-1 flex-col gap-1 text-gray-800">
              <div class="text-sm font-bold">
                {{ item.tanggal != null ? date(item.tanggal) : "-" }}
              </div>

              <p class="text-sm">Scene ID :</p>

              <ul class="text-sm ml-4" v-for="scene in item.scene_id" :key="scene">
                <li id="list">{{ scene }}</li>
              </ul>

              <div class="flex justify-between item-center pt-2">
                <div class="flex gap-1 items-center text-sm">
                  <IconGeofence color="#000000" size="w-5 h-5" />
                  <p>{{ item.kode_petak }}</p>
                </div>

                <button
                  type="button"
                  class="bg-blue-700 text-white h-6 px-1 rounded-sm hover:bg-blue-800"
                  @click="detailScene(item)"
                >
                  <div class="flex items-center justify-between text-sm">
                    <small class="px-2 tetx-xs"> {{ item.jumlah_scene }} SCENES </small>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-4 h-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m8.25 4.5 7.5 7.5-7.5 7.5"
                      />
                    </svg>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="pt-3">
            <hr class="border-gray-200" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="!sgnbykodepetak.loading">
      <div v-if="!bykodepetak.loading">
        <p
          class="text-sm text-gray-500 font-bold px-5 pt-3"
          v-if="bykodepetak.rows?.length != 0"
        >
          Total Scene : {{ bykodepetak.count }}
        </p>
      </div>
    </div>

    <SkeletonDailyScene v-if="bykodepetak.loading || sgnbykodepetak.loading" />

    <div class="flex justify-center -mt-10" v-if="bykodepetak.rows?.length == 0">
      <img src="../../assets/nodata.png" :width="550" :height="550" />
    </div>

    <AlertErrorComponent
      v-if="bykodepetak.error"
      :message="bykodepetak.error.response.data.message"
    />
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { useSceneStore, usesgnksoFeaturesStore } from "@/store";
import { storeToRefs } from "pinia";
import SkeletonDailyScene from "./SkeletonDailyScene.vue";
import AlertErrorComponent from "@/components/AlertErrorComponent.vue";
import { useRoute } from "vue-router";
import moment from "moment";
import * as d3 from "d3";
import IconGeofence from "@/components/icons/IconGeofence.vue";

export default {
  components: {
    SkeletonDailyScene,
    AlertErrorComponent,
    IconGeofence,
  },
  props: {
    selected: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const sceneStore = useSceneStore();
    const { bykodepetak } = storeToRefs(sceneStore);
    const sgnksoFeatureStore = usesgnksoFeaturesStore();
    const { sgnbykodepetak } = storeToRefs(sgnksoFeatureStore);
    const kodepetak = route.params.kode_petak;

    const currentYear = new Date().getFullYear();

    const getSceneByKodePetak = async () => {
      sceneStore.tgl = [];

      await sceneStore.getSceneKodePetak(kodepetak);

      sceneStore.month = bykodepetak.value.rows[0].tanggal;

      bykodepetak.value.rows.forEach((element) => {
        sceneStore.dates.push(element.tanggal);
      });

      sceneStore.currentMonth = moment(sceneStore.dates[0]).format("MMMM");
      const maxDate = new Date(sceneStore.dates[0]);
      const minDate = new Date(sceneStore.dates[sceneStore.dates.length - 1]);
      sceneStore.minPage = minDate.getMonth() + 1;
      sceneStore.maxPage = maxDate.getMonth() + 1;

      const today = new Date(sceneStore.dates[0]);
      const monthNumber = today.getMonth() + 1;
      const key = `${currentYear}-${monthNumber}`;
      sceneStore.page = monthNumber;

      const groupedByMonth = sceneStore.dates.reduce((acc, date) => {
        const year = new Date(date).getFullYear();
        const month = new Date(date).getMonth();
        const monthKey = `${year}-${month + 1}`;

        if (!acc[monthKey]) {
          acc[monthKey] = [];
        }
        acc[monthKey].push(date);
        acc[monthKey].sort((a, b) => new Date(a) - new Date(b));
        return acc;
      }, {});

      sceneStore.tgl = groupedByMonth[key].map((x) => moment(x).format("MM/DD"));
    };

    const getSgnByKodePetak = async () => {
      await sgnksoFeatureStore.getByKodePetak(kodepetak);
    };

    const geoJsonData = reactive({
      type: "FeatureCollection",
      features: [],
    });

    const dataURL = ref("");

    const createimg = () => {
      geoJsonData.features = [];
      if (sgnbykodepetak.value.rows?.length != 0) {
        geoJsonData.features.push(sgnbykodepetak.value.rows[0]);
      }

      // for (let i = 0; i < sgnbykodepetak.value.rows.length; i++) {
      //   geoJsonData.features.push(sgnbykodepetak.value.rows[i]);
      // }

      const width = 85;
      const height = 85;

      const svg = d3.select("#map-svg").attr("width", width).attr("height", height);

      const projection = d3.geoMercator().fitSize([width, height], geoJsonData);
      const path = d3.geoPath().projection(projection);

      svg
        .append("g")
        .selectAll("path")
        .data(geoJsonData.features)
        .enter()
        .append("path")
        .attr("d", path)
        .attr("fill", "#D2E3F9")
        .attr("stroke", "#3388FF")
        .attr("stroke-width", 2.5);

      const svgData = new XMLSerializer().serializeToString(svg.node());
      const svgDataBase64 = btoa(svgData);
      const svgDataUrl = `data:image/svg+xml;base64,${svgDataBase64}`;
      dataURL.value = svgDataUrl;
    };

    onMounted(async () => {
      await getSgnByKodePetak();
      await getSceneByKodePetak();

      createimg();
    });

    const detailScene = (value) => {
      emit("detail", value);
    };

    const date = (date) => {
      return moment(date).format("DD MMM YYYY");
    };

    return {
      bykodepetak,
      detailScene,
      date,
      dataURL,
      sgnbykodepetak,
    };
  },
};
</script>

<style>
#list {
  list-style-type: disc;
}
</style>
